import React, {useReducer, useEffect} from 'react'
import DefaultModal from '../Utils/DefaultModal';
import { lockedReducer } from '../Utils/reducers';
import { Box, Tooltip, IconButton} from '@mui/material'
import SendBox from './sendBox';
import clsx from 'clsx';
import { DataGrid } from '@mui/x-data-grid';
import ColorButton from '../Buttons/ColorButton';
import Typography from '@mui/material/Typography';
import ConfirmationDialog from '../Utils/ConfirmationDialog';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SearchCodpro from './searchCodpro';
import { api } from '../../services/api';
import toast from 'react-hot-toast';
import { balanceFunc,validateBalance,validateAmount } from '../Utils/balance';

const validateSave = (data) => {

    const response = []
    if (data?.invoiceList.length === 0){
        response.push(<Box>Selecione um produto.</Box>)
    }

    if(validateBalance(data?.invoiceList,true)){
            response.push(<Box>Não pode haver balanço negativo.</Box>)  
    }
    
    if(validateAmount(data?.invoiceList)){
        response.push(<Box>Quantidade não pode ser zero.</Box>)
    }

    if (response.length === 0)
        return ''

    return (response)
}

const openModal = (setState,data,url) => {
    setState({invoiceModal:true})
    consultFile(setState,data,url)
}

const consultFile = async (setState, data, url) => {
    const resInvoice = await api.get(url + `${data.id}/consult_file/`)
    if (resInvoice.status === 200) {
        setState({invoiceList:resInvoice.data})
    }
}


const InvoiceModal = ({data, setLoader, reloadData, setPreviousState, type, retrieve}) => {

    const url = '/importacao/'

    const [state, setState] = useReducer(lockedReducer, {

        invoiceModal:null,
        deleteRow:null,
        invoiceList:data.invoice,
        deleteLine:null,
        
    })

    const validData = validateSave(state)

   
    const deleteInvoice = async () => {
        setLoader(true)
            await api.patch(`${url}${data.id}/delete_invoice/`)
            await api.post(`${url}remove_invoice/`, data)
            consultFile(setState, data, url)
            retrieve(data.id, setPreviousState, setLoader,'/importacao/') 
            setState({ deleteRow: null})
            setPreviousState({invoice:[]})
            reloadData()
        setLoader(false)
    
    }

    const handleClose = async () => {
        setState({invoiceModal:null})

        consultFile(setState,data,url)
      
    }

    const setNewList = (rows) => {
        setState({invoiceList:rows})
    }

    const deleteLine = () => {
        const row = state.deleteLine
        const newRows = state.invoiceList.filter(each =>  each.id !== row.id)
        const rowB = state.invoiceList.filter(each =>  each.id === row.id)
        setState({invoiceList:newRows,deleteLine:null})
        
    }

    const saveProduct = async (state,setInvoice,setState,reloadData) => {

        toast.success('Editado com sucesso')
        setInvoice({invoice:state.invoiceList})
        setState({invoiceModal:null})
        reloadData()
    
    }


    const columns = [

        {
            field: 'ordernumber',
            headerName: 'Mês/Ano',
            flex: 0.1,
            cellClassName: () => {
                return clsx('default-app', {
                    selected: true ,
                });
            }

        },
        {
            field: 'filename',
            headerName: 'Documento',
            flex: 0.2,
            cellClassName: () => {
                return clsx('default-app', {
                    selected: true ,
                });
            }

        },
        {
            field: 'product',
            headerName: 'Codpro',
            flex: 0.1,
            cellClassName: () => {
                return clsx('default-app', {
                    selected: true ,
                });
            }

        },
        {
            field: 'description',
            headerName: 'Descrição',
            flex: 0.4,
            cellClassName: () => {
                return clsx('default-app', {
                    selected: true ,
                });
            },
            renderCell: (params) => (
                <Box sx={{display:'flex',flexDirection:'column', width:'100%',justifyContent:'start'}}>
                  
                    {params.value}
                </Box>
              ),

        },
        {
            field: 'amount',
            headerName: 'Quantidade',
            flex: 0.2,
            cellClassName: () => {
                return clsx('default-app', {
                    selected: true ,
                });
            },
            renderCell: (params) => ( 
                <Box>
                    <SendBox quantity={params.value} row={params.row} reload={()=> setState({...state})} />
                </Box>
            ),
        },
        { field: 'balance', headerName: 'Balanço', flex: 0.2, filterType: 'number',
            cellClassName: () => {
                return clsx('default-app', {
                    selected: true ,
                });
            },
            renderCell: (params) => (
                <Box>
                    {balanceFunc(params.row,!type)}
                </Box>
            )
         },
        {
            field: 'price',
            headerName: 'Preço',
            flex: 0.1,
            cellClassName: () => {
                return clsx('default-app', {
                    selected: true ,
                });
            },
            renderCell: (params) => ( 
                <Box>
                   $ {params.value},00 
                </Box>
            ),

        },
        {
            field: 'trash',
            headerName: '',
            flex: 0.1,
            cellClassName: () => {
                return clsx('default-app', {
                    selected: true ,
                });
            },
            renderCell: (params) => ( 
                <Box>
                    <Tooltip title="Excluir linha"><IconButton onClick={()=> setState({deleteLine:params.row})}> <DeleteIcon/></IconButton></Tooltip>
                </Box>
            ),

        }

    ]

    useEffect(() => {

        consultFile(setState,data,url)
     
        try {
            
            const newRows = state.invoiceList?.sort((a, b) => a.description.localeCompare(b.description))
            setState({invoiceList:newRows})

        } catch (error) {
            
        }
        
        
        

    }, [data.change])

   
    return (
        <>

        {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir o pedido invoice ?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={deleteInvoice}
                />
         }

        {state.deleteLine &&
                <ConfirmationDialog
                    content={`Deseja excluir essa linha ?`}
                    handleClose={() => setState({ deleteLine: null })}
                    onConfirm={deleteLine}
                />
         }

        { state.invoiceModal &&

            <DefaultModal
                    title={
                        `Produtos - Editando Invoice`
                    }
                    dialogProps={{
                        sx:{'& .MuiPaper-root': {
                            maxWidth:'unset',
                            maxHeight:'unset',
                            width: '80%',
                            height:'80%',
                            margin:'0px',

                            '@media (min-width: 1600px)': {
                                width: '60%', // Largura para telas maiores
                                height: '80%', // Altura para telas maiores
                            },
                        }}
                    }}
                    handleClose={handleClose}
                    content={
                        <>

                        {
                            type ?
                            null
                            :
                            <Box>
                                <SearchCodpro 
                                reloadData={retrieve} 
                                data={data} setPreviousState={setPreviousState} setLoader={setLoader} rowsB={state.invoiceList} invoiceList={state.invoiceList} setNewList={setNewList}/>
                            </Box>
                        }

                        <Box sx={{display:'flex',flexDirection:'column',gap:'3rem',height:'100%',overflow:'hidden'}}>

                            <Box sx={{flex:1, minHeight:'1rem'}} >  
                                <DataGrid
                                    sx={{
                                        '& .default-app.selected': {
                                            justifyContent:'center',
                                            alignItems:'center',
                                            fontSize:'14px'
                                        },
                                        height:"24rem",
                                        '& .MuiDataGrid-columnHeaderTitleContainer': {
                                            justifyContent: 'center',
                                        },
                                        '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
                                            color:'black'
                                        }
                                    
                                    }}
                                    className='alterned_grid'
                                    rows={state.invoiceList}                                                                                                                                                                                                                                                                                                                                                                                                                       
                                    columns={columns}
                                    pagination={false}
                                    density='compact'
                                    pageSize={5}
                                    rowHeight={30}
                                />
                            </Box>

                        </Box>
                        
                        </>
                    }
                    action={
                        <>
                        {
                            type ?
                            null
                            :
                            
                            <Tooltip placement="left" title={validData}>
                                <Box>
                                    <ColorButton
                                    onClick={() => saveProduct(state,setPreviousState,setState,reloadData)}
                                    disabled={validData}
                                    >Concluir
                                    </ColorButton>
                                </Box>
                            </Tooltip>
                            
                        }
                        </>
                    }
                />

        }


        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                '& > :not(style)': {
                m: 1,
                width: '100%',
                height: '4rem',
                alignItems:'center',
                justifyContent:'space-evenly'
                },
            }}
        >

            <Paper elevation={1} sx={{display:'flex'}}>

                <Box>
                    <Typography>Pedido Invoice:</Typography>
                </Box>

                <Box sx={{width:'15rem'}}/>

                <Box>
                    <Tooltip title="Visualiza o invoice"><IconButton onClick={() => openModal(setState,data,url)}><RemoveRedEyeIcon/></IconButton></Tooltip>
                    {
                        type ?
                        <Tooltip title="Deleta invoice"><IconButton onClick={() => {setState({ deleteRow: true })}  }><DeleteIcon/></IconButton></Tooltip>
                        : null
                    }       
                </Box>
                
            </Paper>

        </Box>

        </>
    )
}

export default InvoiceModal;